import styled from 'styled-components';
import { nuDSColor } from '@nubank/nuds-web/styles/themeUtils';

import { themeSpace } from 'styles/themeUtils';

export const MediaGallery = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
`;

MediaGallery.displayName = 'MediaGallery';

export const MediaContent = styled.div`
  flex: 1 0 41%;
  margin: ${themeSpace(1)};
  border: 1px solid ${nuDSColor('black', 'defaultT70')};
  text-align: center;
  position: relative;

  img {
    height: auto;
    width: 100%;
    max-width: 100%;
    display: block;
    border-style: none;
  }
`;

MediaContent.displayName = 'MediaContent';

export const MediaContentFooter = styled.div`
  padding: ${themeSpace(1)};
  border-top: 1px solid ${nuDSColor('black', 'defaultT70')};

  svg {
    margin-right: ${themeSpace(1)};
  }
`;

MediaContentFooter.displayName = 'MediaContentFooter';
